import { useMediaQuery, useTheme } from '@material-ui/core'
import { SERVICES_URL, TranslationDictionary } from '@plandi/common'
import React, { FC } from 'react'
import { EmptyContent, Loader } from 'src/common'
import {
  MyProfileSpecialist,
  ProfileSpecialistBasicDataNew,
  ProfileSpecialistEducationNew,
  ProfileSpecialistExperienceNew,
  ProfileSpecialistSpecializationNew,
  ProfileSpecialistWorkingConditionsNew
} from '../common'
import { ProfileSpecialistPortfolioNew } from '../common/profile-specialist-portfolio-new/profile-specialist-portfolio-new'

interface IMyProfileSpecialistNewProps {
  profile?: MyProfileSpecialist
  isLoading: boolean
  translate?: TranslationDictionary['data']
  locale: string
  type: 'freelancer' | 'worker'
  hideEdit?: boolean
}

export const MyProfileSpecialistNew: FC<IMyProfileSpecialistNewProps> = ({
  profile,
  isLoading,
  translate,
  locale,
  type,
  hideEdit
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(900))
  const url = SERVICES_URL

  if (isLoading) {
    return <Loader />
  }

  if (!profile) {
    return (
      <EmptyContent
        showButton
        message={
          locale === 'ru'
            ? `У вас пока нет анкеты ${
                type === 'freelancer' ? 'фрилансера' : 'наёмного работника'
              }. Создайте анкету чтобы иметь
    возможность откликаться на заказы и вакансии`
            : `You don't have a profile yet ${
                type === 'freelancer' ? 'freelancer' : 'hired employee'
              }. Create a profile to have
    opportunity to respond to orders and vacancies`
        }
        buttonProps={{
          href:
            locale === 'ru'
              ? `${url.job}/ru` + `/profile-specialist/${type}/create`
              : url.job + `/profile-specialist/${type}/create`,
          text: translate?.['job-site']?.['create-profile'] ?? 'Создать анкету'
        }}
      />
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: isMobile ? 16 : 24
      }}
    >
      <ProfileSpecialistBasicDataNew
        profile={profile}
        locale={locale}
        translate={translate}
        type={type}
        hideEdit={hideEdit}
      />
      <ProfileSpecialistSpecializationNew
        profile={profile}
        locale={locale}
        translate={translate}
        type={type}
        hideEdit={hideEdit}
      />
      <ProfileSpecialistWorkingConditionsNew
        profile={profile}
        locale={locale}
        translate={translate}
        type={type}
        hideEdit={hideEdit}
      />
      <ProfileSpecialistPortfolioNew
        profile={profile}
        locale={locale}
        translate={translate}
        type={type}
        hideEdit={hideEdit}
      />
      <ProfileSpecialistExperienceNew
        profile={profile}
        locale={locale}
        translate={translate}
        type={type}
        hideEdit={hideEdit}
      />
      <ProfileSpecialistEducationNew
        profile={profile}
        locale={locale}
        translate={translate}
        type={type}
        hideEdit={hideEdit}
      />
    </div>
  )
}
